import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, GraduationCapIcon } from 'lucide-react';
import { universities, slugify } from '../data/universityData';
import { useMetaTags } from '../hooks/useMetaTags';
export function PartnerCollegesPage() {
  useMetaTags({
    title: 'Partner Colleges | FindOnlineDegrees',
    description: 'Explore our partner colleges and request information directly from accredited schools offering programs that fit your goals.'
  });
  const partners = Object.values(universities);
  return <div className="bg-gray-100 min-h-screen" data-id="element-2037" data-mp="30c5ni9jeutd1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2038" data-mp="35d32yed1d9au">
        {/* Header */}
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-2039" data-mp="3abwew2cocs8w">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#e8594f]/10 text-[#e8594f] mb-3" data-id="element-2040" data-mp="3ab4xpwjtqx25">
            Partner Network
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-2041" data-mp="1fyf2nbhpzht6">
            Our Partner Colleges
          </h1>
          <p className="text-gray-600 leading-relaxed" data-id="element-2042" data-mp="2j67pe9ra190k">
            Browse the accredited colleges and universities we partner with.
            Click any school to request information directly from their
            admissions team.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2043" data-mp="25eksq8tf9yh9">
          {partners.map(uni => {
          const href = `/universities/${uni.slug}`;
          return <Link key={uni.slug} to={href} className="group bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-gray-300 transition-all overflow-hidden flex flex-col" data-id="element-2044" data-mp="2x4z1xrqhqmml">
                {/* Branded color bar */}
                <div className="h-2 w-full" style={{
              backgroundColor: uni.primaryColor
            }} data-id="element-2045" data-mp="2o5c0j5xrhgtj" />

                <div className="p-6 flex flex-col flex-grow" data-id="element-2046" data-mp="1co2i8mqdcutt">
                  {/* Logo */}
                  <div className="h-16 mb-4 flex items-center" data-id="element-2047" data-mp="1e5834ict1lke">
                    {uni.logoUrl ? <img src={uni.logoUrl} alt={uni.name} className="max-h-16 max-w-[200px] object-contain" data-id="element-2048" data-mp="1e353d6luoe2h" /> : <div className="flex items-center gap-2 text-gray-700" data-id="element-2049" data-mp="1j3jbeongbo0i">
                        <GraduationCapIcon className="w-6 h-6" data-id="element-2050" data-mp="153rw8kl781kx" />
                        <span className="font-bold" data-id="element-2051" data-mp="195lpw8wz85bl">{uni.shortName}</span>
                      </div>}
                  </div>

                  <h2 className="text-lg font-bold text-gray-900 mb-1 leading-tight" data-id="element-2052" data-mp="vdp04bis67id">
                    {uni.name}
                  </h2>
                  <p className="text-sm text-gray-500 mb-4" data-id="element-2053" data-mp="1079rvlts6594">{uni.tagline}</p>

                  {/* Quick facts */}
                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-2054" data-mp="qfna16mxt7xe">
                    <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700 font-medium" data-id="element-2055" data-mp="qfx00u7zff33">
                      {uni.accreditation}
                    </span>
                    <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-700 font-medium" data-id="element-2056" data-mp="hdxk658peh1q">
                      Founded {uni.founded}
                    </span>
                  </div>

                  {/* Degree levels */}
                  <div className="text-xs text-gray-500 mb-5" data-id="element-2057" data-mp="3p1t8nzelyjvc">
                    <span className="font-semibold text-gray-700" data-id="element-2058" data-mp="6un3t2xot0d0">
                      Degree Levels:
                    </span>{' '}
                    {uni.degreeLevels.join(', ')}
                  </div>

                  {/* Spacer + CTA */}
                  <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-2059" data-mp="bsydndnzfav8">
                    <span className="text-sm text-gray-500" data-id="element-2060" data-mp="qhkxnsok0qss">
                      {uni.programs.length} program
                      {uni.programs.length !== 1 ? 's' : ''}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold group-hover:gap-2.5 transition-all" style={{
                  color: uni.ctaColor
                }} data-id="element-2061" data-mp="zhzo16gdkw35">
                      Request Info
                      <ArrowRightIcon className="w-4 h-4" data-id="element-2062" data-mp="2oyld4yp1ochs" />
                    </span>
                  </div>
                </div>
              </Link>;
        })}
        </div>

        {/* Disclosure */}
        <p className="text-xs text-gray-400 text-center mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-2063" data-mp="2yqiwisq7iarl">
          FindOnlineDegrees.org is an advertising-supported site. Featured
          schools compensate us for leads. Compensation may impact placement,
          but does not influence our editorial content.
        </p>
      </div>
    </div>;
}